export const mockup = [
  {
    _id: '1234',
    name: 'test 1',
    startdate: '01/10/2020',
    // enddate: vm.$moment(user.cat).format('DD/MM/YYYY HH:mm'),
    enddate: '05/10/2020',
    provider: 'Mondo',
    publicKey: 'Test',
    gameId: 1234,
    playerId: 2345,
    promotionId: 3456,
    freeRoundCount: 7,
    currency: 'EU',
    amount: 89,
    status: {
      text: 'Enabled',
      value: 1
    },
  },
  {
    _id: '1231',
    name: 'test 2',
    startdate: '01/09/2020',
    enddate: '05/09/2020',
    provider: 'Golden Raze',
    publicKey: 'Test 2',
    gameId: 11234,
    playerId: 12345,
    promotionId: 13456,
    freeRoundCount: 17,
    currency: 'EU',
    amount: 189,
    status: {
      text: 'Disabled',
      value: 0
    },
  }
];

export const mockFields = [
  {
    "type":"string",
    "label":"campo string",
    "name":"str",
    "validators": {
      "required":true,
    },
  },
  {
    "type":"select",
    "label":"campo select",
    "name":"sel",
    "validators":{
      "required":true,
    },
    "items":[
      {"text":"opcion 1", "value":"op1"},
      {"text":"opcion 2", "value":"op2"}
    ]
  },
  {
    "type":"string",
    "label":"campo host",
    "name":"hos",
    "validators": {
      "host":true,
    },
  },
  {
    "type":"string",
    "label":"campo email",
    "name":"em",
    "validators": {
      "email":true,
    },
  },
  {
    "type":"date",
    "label":"campo date",
    "name":"dat",
  },
  {
    "type":"string",
    "label":"campo number",
    "name":"num",
    "validators": {
      "min_value": 5,
      "max_value": 15,
    },
  },
  {
    "type":"string",
    "label":"campo number 2",
    "name":"num2",
    "validators": {
      "min_value": "5",
    },
  },
];